import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { CurrentUserService } from 'services/currentUser';
import { getActiveWindPartnerProduct, isEligibleForWindCoverage } from 'common/source/utilities/policyInfoHelper';
import { IAugmentedJQuery } from 'angular';
import * as _ from 'lodash';

const module = angular.module('coverage-wind-coverage-section', []);

interface CoverageWindCoverageSectionController extends angular.IStrictController {
    title: string;
    icon: string;
    description: string;
    partnerContactNumber: string;
    partnerName: string;
    policyNumber: string;
    policyInfo: CustomerPolicyInfo;
}

module.component('coverageWindCoverageSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(
        this: CoverageWindCoverageSectionController,
        currentUserService: CurrentUserService,
        $element: IAugmentedJQuery
    ) {
        'ngInject';

        this.$onInit = () => {
            this.title = 'Wind';
            this.icon = 'wind';

            const activeWindPartnerProduct = getActiveWindPartnerProduct(this.policyInfo);

            if (activeWindPartnerProduct) {
                this.partnerContactNumber = activeWindPartnerProduct.carrier === 'velocity' ? '844-878-7529' : '';
                this.partnerName = _.startCase(activeWindPartnerProduct.carrier);
                this.policyNumber = activeWindPartnerProduct.policy_number;
                this.description = `
                    Smart move. You purchased wind coverage, with a policy effective date of ${
                        activeWindPartnerProduct.date
                    }.`;
            } else if (!isEligibleForWindCoverage(this.policyInfo)) {
                $element.addClass('ng-hide');
            } else {
                $element.find('icon-title-section').addClass('ng-hide');
            }
        };
    }
});

export { module };
